import gql from 'graphql-tag';

export const updateNotification = gql`
  mutation UpdateNotificationStatus($input: UpdateNotificationStatusInput!) {
    updateNotificationStatus(input: $input)
  }
`;

export const sendNotification = gql`
  mutation SendNotification(
    $emailTemplate: String
    $inAppMessageId: String
    $inAppTitleId: String
    $locale: String
    $notificationData: String
    $notificationType: String!
    $receiverId: String!
    $receiverUsername: String!
    $userID: String!
  ) {
    sendNotification(
      emailTemplate: $emailTemplate
      inAppMessageId: $inAppMessageId
      inAppTitleId: $inAppTitleId
      locale: $locale
      notificationData: $notificationData
      notificationType: $notificationType
      receiverId: $receiverId
      receiverUsername: $receiverUsername
      userID: $userID
    )
  }
`;
